<script lang="ts">
	import BtnPrimary from '$lib/buttons/v2/btnPrimary.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import { type ISbRichtext, type ISbStoryData } from '@storyblok/js';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import type { ImageBlock } from './imageBlock.svelte';
	import Blok from '../blok.svelte';
	import { editable } from '../editable';

	export let content: ISbStoryData<{
		assets: Array<ISbStoryData<ImageBlock>['content']>;
		headline: ISbRichtext;
		subline: ISbRichtext;
	}>['content'];
</script>

<section
	use:editable={content}
	id="hero"
	data-testid="hero-section"
	class="relative min-h-svh bg-[#001A10] pb-[28px] max-lg:flex max-lg:flex-col max-lg:justify-between lg:flex lg:items-end lg:pb-22"
>
	<div class="flex max-lg:flex-1 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:flex-col">
		{#each content.assets as asset}
			<div class="lg:h-1/2">
				<Blok content={asset} />
			</div>
		{/each}
	</div>
	<PageGrid16 class="relative max-2xl:px-5 max-lg:pt-10 lg:h-full" gridClass="h-full">
		<div
			class="col-span-full flex flex-col justify-end gap-y-4 lg:col-start-1 lg:col-end-8 lg:gap-y-5"
		>
			<div
				class="font-rhymes text-[60px]/[90%] tracking-[-2.4px] text-[#F8F4EB] lg:text-[100px]/[90%] lg:tracking-[-3px]"
			>
				<SbRichtext text={content.headline} />
			</div>
			<div
				class="text-[16px]/[140%] tracking-[-.16px] text-[#79D397] lg:text-[24px]/[140%] lg:tracking-[-.24px]"
			>
				<SbRichtext text={content.subline} />
			</div>
			<div class="mt-3 flex items-center gap-x-3">
				<BtnPrimary theme="nyc-green" size="large" href="/lp/nyc"
					><span class="lg:hidden">Get started</span><span class="max-lg:hidden">Learn more</span
					></BtnPrimary
				>
				<BtnPrimary theme="white" size="large" href="/food-recycler">Buy now</BtnPrimary>
			</div>
		</div>
	</PageGrid16>
</section>
